import { render, staticRenderFns } from "./RedCalendar.vue?vue&type=template&id=1c2d2420&scoped=true"
import script from "./RedCalendar.vue?vue&type=script&lang=js"
export * from "./RedCalendar.vue?vue&type=script&lang=js"
import style0 from "./RedCalendar.vue?vue&type=style&index=0&id=1c2d2420&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2d2420",
  null
  
)

export default component.exports